import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    chip: {
        display: 'flex',
        flexDirection: 'row',
        border: 'solid 1px rgba(44, 45, 62, 0.3)',
        borderRadius: '15px',
        margin: '15px',
        width: '380px'
    },
    valueField: {
        minWidth: '60px',
        padding: '20px',
        borderRight: 'solid 1px rgba(44, 45, 62, 0.3)',
    },
    value: {
        fontFamily: 'Roboto',
        fontSize: '30px',
        color: 'rgb(60, 65, 154)',
        fontWeight: 'bold'
    },
    nameField: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
    },
    name: {
        fontFamily: 'Roboto',
        fontSize: '15px',
    },
    noData: {
        display: 'flex',
        height: '200px',
        justifyContent: 'center',
        fontFamily: 'Roboto',
        alignItems: 'center',
        fontSize: '14px'
    }
}));
